<template>
  <div class="discussion-block-section">
    <div class="title-text font-weight-bold color_grey_dark">PARTICIPANT</div>
    <DiscussionCard></DiscussionCard>
    <DiscussionCard></DiscussionCard>
    <DiscussionCard></DiscussionCard>
  </div>
</template>

<script>
import DiscussionCard from "@/components/classComps/library/DiscussionCard";

export default {
  name: "DiscussionBlock",

  components: {
    DiscussionCard,
  },
};
</script>

<style lang="scss" scoped>
.discussion-block-section {
  .title-text {
    font-size: 14px;
    line-height: 19px;
    margin-bottom: 20px;
  }
}
</style>